<template>
  <div class="container">
    <side-bar-info></side-bar-info>
    <document></document>
    <document-footer></document-footer>
    <modal name="helpModal" :header="$t('functional.help')">
      <help></help>
      <template slot="modalButtons" slot-scope="props">
        <app-button :text="$t('functional.close')" iconName="times" :action="props.close"></app-button>
      </template>
    </modal>
    <modal
      name="rejectModal"
      :header="$t('functional.rejectEnvelope')">
        <reject-document></reject-document>
        <template slot="modalButtons" slot-scope="props">
          <app-button :text="$t('functional.close')" iconName="times" :action="props.close"></app-button>
          <app-button :text="$t('functional.reject')" iconName="trash" :action="rejectDocument" classList="float-right button--cancel"></app-button>
        </template>
      </modal>
    <modal name="widgetPartyInfoModal" :header="$t('widgetVerify.title')">
      <widget-verify></widget-verify>
    </modal>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton'
import SideBarInfo from '@/components/SideBarInfo'
import Help from '@/components/Help'
import RejectDocument from '@/components/RejectDocument'
import WidgetVerify from '@/components/WidgetVerify'
import Document from '@/components/Document'
import Modal from '@/components/Modal'
import DocumentFooter from '@/components/Footer'

export default {
  name: 'index',
  components: {
    AppButton,
    SideBarInfo,
    Help,
    RejectDocument,
    WidgetVerify,
    Modal,
    Document,
    DocumentFooter
  },
  methods: {
    rejectDocument () {
      this.$bus.$emit('rejectDocument')
    }
  }
}
</script>

<style lang="sass" scoped>
  .overlay
    position: absolute
    top: 0
    left: 0
    height: 100%
    width: 100%
    background: rgba(0, 0, 0, 0.6)
    z-index: 999
  .float-right
    float: right
</style>
